import { render } from "./STDSCM01C05TearmsOfServiceModal.vue?vue&type=template&id=f65383fe&scoped=true"
import script from "./STDSCM01C05TearmsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./STDSCM01C05TearmsOfServiceModal.vue?vue&type=script&lang=js"

import "./STDSCM01C05TearmsOfServiceModal.vue?vue&type=style&index=0&id=f65383fe&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65383fe"]])

export default __exports__